/**
 * Learner Web SEO — apex examflow.cn public marketing only.
 * See docs/engineering/web-seo.md.
 */

export const SITE_ORIGIN = 'https://examflow.cn';
export const DEFAULT_OG_IMAGE_PATH = '/og-default.png';

/** Static fallback aligned with visitor hero (learning-space). */
export const HOME_SEO_TITLE = '考流 · ExamFlow — 多语考试空间';
export const HOME_SEO_DESCRIPTION =
  '开通后：摸底 → 按天练。专项训练随时开随时停，不把官方模考题量当成日常。';

export type SeoRobots = 'index, follow' | 'noindex, nofollow';

export interface RouteSeoDescriptor {
  title: string;
  description: string;
  canonicalPath: string;
  robots: SeoRobots;
  ogType: 'website' | 'article';
  jsonLd?: Record<string, unknown>;
}

export function absoluteUrl(path: string): string {
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_ORIGIN}${normalized}`;
}

export function ogImageUrl(): string {
  return absoluteUrl(DEFAULT_OG_IMAGE_PATH);
}
